import { type RoleId, roles } from "../content/roles";

interface RoleSelectorProps {
  value: RoleId;
  onChange: (value: RoleId) => void;
}

export function RoleSelector({ value, onChange }: RoleSelectorProps) {
  return (
    <div className="waitlist-form__group">
      <select
        className="select"
        value={value}
        onChange={(e) => onChange(e.target.value as RoleId)}
        aria-label="Your role"
      >
        {roles.map((r) => (
          <option key={r.id} value={r.id} disabled={r.id === "" && value !== ""}>
            {r.label}
          </option>
        ))}
      </select>
    </div>
  );
}
